module.exports = __webpack_public_path__ + "img/migo-light.b3495d05.svg";